import { usePage } from '@inertiajs/react';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function CardAlert() {
  const { props } = usePage();

  const planExpired = props.current.organization.plan_expired;

  const handleRenewPlan = () => {
    window.location.href = 'mailto:support@drivesync.com.br?subject=Renovação de plano&body=Olá, gostaria de renovar meu plano!';
  };

  if (props.current.organization.plan_expires_at === null || props.current.organization.days_until_plan_expiry > 15) {
    return null;
  }

  return (
    <Card variant="outlined" sx={{ m: 1.5, flexShrink: 0 }}>
      <CardContent>
        <AutoAwesomeRoundedIcon fontSize="small" sx={{ color: planExpired ? 'error.main' : 'warning.light' }} />
        <Typography gutterBottom sx={{ fontWeight: 600 }}>
          {planExpired ? 'Plano expirado' : 'Plano expirando'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          {planExpired ? 'Seu plano expirou. Por favor, entre em contato com o suporte para renovar.' : `Seu plano expira em ${props.current.organization.days_until_plan_expiry} ${props.current.organization.days_until_plan_expiry === 1 ? 'dia' : 'dias'}.`}
        </Typography>
        <Button variant="contained" size="small" fullWidth onClick={handleRenewPlan}>
          {planExpired ? 'Renovar agora' : 'Renovar plano'}
        </Button>
      </CardContent>
    </Card>
  );
}
